import { render, staticRenderFns } from "./SecundarySurveyV2View.vue?vue&type=template&id=7ab63ba8&scoped=true&"
import script from "./SecundarySurveyV2View.vue?vue&type=script&lang=ts&"
export * from "./SecundarySurveyV2View.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ab63ba8",
  null
  
)

export default component.exports